var _style, _circle, _path, _path2, _path3, _line, _line2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTtKolongrafia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D70000;}\r\n\t.st1{fill:#009245;}\r\n\t.st2{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st3{stroke:#000000;stroke-miterlimit:10;}\r\n\t.st4{fill:#FFFFFF;stroke:#000000;stroke-width:1.5;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st5{fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st6{fill:none;stroke:#000000;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st7{fill:none;stroke:#000000;stroke-width:0.75;stroke-miterlimit:10;}\r\n\t.st8{fill:none;stroke:#000000;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st9{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st10{fill:#004B87;}\r\n\t.st11{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st12{fill:#FFFFFF;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st13{fill:none;stroke:#FFFFFF;stroke-linecap:round;stroke-miterlimit:10;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 15,
    cy: 15,
    r: 13
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M14.22,8.46c0,0-0.582,2.136,0.597,3.64c0.768,0.98,1.275,2.422,0.69,3.813 c-0.91,2.167-3.138,2.369-4.386,2.369"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M10.897,19.62c0,0,2.963,2.135,6.139,1.497c2.444-0.491,3.557-2.217,4.145-3.766 c0.518-1.363,0.349-4.275-1.4-5.75c-0.918-0.775-2.352-0.966-3.02-1.419c-0.298-0.202-0.927-1.006-0.927-1.774"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M20.931,23.111H9.073c-1.158,0-2.097-0.939-2.097-2.097V8.602c0-1.158,0.939-2.097,2.097-2.097h11.857 c1.158,0,2.097,0.939,2.097,2.097v12.411C23.028,22.171,22.089,23.111,20.931,23.111z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 8.936,
    y1: 10.78,
    x2: 11.412,
    y2: 10.78
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 8.936,
    y1: 8.692,
    x2: 12.445,
    y2: 8.692
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTtKolongrafia);
export default __webpack_public_path__ + "static/media/icon_tt_kolongrafia.7606c596902b324750f01514af8f812a.svg";
export { ForwardRef as ReactComponent };